<template>
  <div class="flex w-full max-w-[1860px] h-full">
    <aside class="hidden md:block md:flex-shrink-0 md:order-1 overflow-y-auto border-r" :key="componentKey">

      <div class="h-full relative flex flex-col sm:w-[260px] overflow-y-auto bg-white">
        <div class="px-4 pt-4 text-sm font-medium text-gray-700">
          {{ $t(`menus.${replaceSpace(moduleName).toLowerCase()}`) }}
        </div>

        <div v-if="menu.length > 0">
          <div v-for="area in menu" :key="area.name">

            <!-- <nav aria-label="{{area.name}}" class=" pt-1 ">
                  <div class="max-w-3xl mx-auto pt-2 px-4 flex items-start ">
                    <div class=" inline-flex items-center text-sm font-light text-gray-600">
                      <span class="uppercase text-[11px]">{{ $t(`menus.${replaceSpace(area.name).toLowerCase()}`)
                        }}</span>
                    </div>
                  </div>
                </nav> -->

            <ul role="list" class=" mt-4">
              <router-link v-for="option in area.options" :key="option.name" :to="{ path: option.path }">
                <li @click="forceRerender()" class="relative mx-4 p-2.5 mb-1 px-2.5  rounded-md" :class="{
                  isActiveMenuClass: isActive(option.path),
                  isInactiveMenuClass: !isActive(option.path)
                }">


<!-- {{ option.name }} -->
                  <div class="flex justify-end space-x-3 ">
                    <div class="min-w-0 flex gap-2">
                      <div class="focus:outline-none flex gap-2 items-center">
                        <div v-if="option.color" class="inline-flex h-2 w-2 rounded-full opacity-75"
                          :class="option.color" />
                        <div class="text-xs truncate">{{ $t(`menus.${replaceSpace(option.name).toLowerCase()}`) }}
                        </div>
                        <div v-if="option.count" class="text-[10px] text-gray-400">{{ option.count }}</div>
                      </div>
                    </div>
                  </div>


                </li>
              </router-link>
            </ul>

          </div>
        </div>
        <div v-else class="px-4">

          <div class="flex justify-center items-center gap-2 text-sm -ml-4 mt-2">
            <FolderOpenIcon class="h-6 w-6  text-gray-500" />

            Nenhuma opção disponível

          </div>

        </div>

      </div>
    </aside>


    <TemplatePageDefault class="sm:px-10 bg-gradient-left-to-right pt-6 overflow-y-auto">
      <slot />
    </TemplatePageDefault>

  </div>

</template>

<script>


import TemplatePageDefault from './_pageDefault.vue'

import { FolderOpenIcon } from "@heroicons/vue/24/outline";

export default {
  name: "LayoutMenu",

  data() {
    return {
      menu: [],
      moduleName: '',
      componentKey: 'intial',
    }
  },
  methods: {
    // Verifica se a string existe na url atual
    isActive(string) {
      let url = window.location.href;
      return url.includes(string);
    },
    forceRerender() {
      this.componentKey = new Date().getTime();
    },
    replaceSpace(string) {
      // remove , . - 
      string = string.replace(/[,.-]/g, "");
      return string.replace(/ /g, '_');
    }
  },
  components: {
    FolderOpenIcon,
    TemplatePageDefault,
  },
  created() {
    this.menu = this.$RouteService.getRouteAreas(this.$route.path);
    this.moduleName = this.$RouteService.getModuleNameOrRoute(this.$route.path);
    this.forceRerender();
  },



}
</script>


<style scoped>
.isActiveMenuClass {
  @apply bg-gray-900 text-white font-medium;
}

.isInactiveMenuClass {
  @apply text-gray-500;
}

.isInactiveMenuClass:hover {
  @apply bg-gray-100 text-gray-900;
}
</style>